export default "__VITE_ASSET__UZnHun$g__"